




















import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class Tools extends Vue {
  @Prop() event!: void;
  @Prop() icon!: string;
  @Prop() desctiption: null | string;
}
